export default "__VITE_ASSET__BBi6Qv4I__"